
import { put, call } from 'redux-saga/effects'

import { BFFAgent } from '../../../../common/BFFAgent'
import {
  STOCK_TAKING_CAR_MANAGEMENT_EXCHANGE_RATES_DATA_MASTER_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_EXCHANGE_RATES_DATA_MASTER_FAILURE
} from '../constants'

export function* getExchangeRatesDataMasterSaga() {
  try {
      const result =  yield call(BFFAgent.Datamasters.getCurrencies)
      const exchangeRatesList = result?.exchanges

      yield put({
          type: STOCK_TAKING_CAR_MANAGEMENT_EXCHANGE_RATES_DATA_MASTER_SUCCESS,
          data: exchangeRatesList
      })
      
  } catch (error) {
    yield put({
      type: STOCK_TAKING_CAR_MANAGEMENT_EXCHANGE_RATES_DATA_MASTER_FAILURE,
      data: { error }
    })
  }
}
